export default __webpack_public_path__ + "static/media/msg.019f2a0e.svg";